import { render, staticRenderFns } from "./formEletronicIdentification.vue?vue&type=template&id=a733464a&scoped=true"
import script from "./formEletronicIdentification.vue?vue&type=script&lang=js"
export * from "./formEletronicIdentification.vue?vue&type=script&lang=js"
import style0 from "./formEletronicIdentification.vue?vue&type=style&index=0&id=a733464a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a733464a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a733464a')) {
      api.createRecord('a733464a', component.options)
    } else {
      api.reload('a733464a', component.options)
    }
    module.hot.accept("./formEletronicIdentification.vue?vue&type=template&id=a733464a&scoped=true", function () {
      api.rerender('a733464a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fiscalDocuments/mdfe/components/form/steps/formEletronicIdentification.vue"
export default component.exports